import store from '@/store/'

export default [
  {
    path: '/company',
    name: 'company',
    component: () =>
      import(
        /* webpackChunkName: 'company-settings-index' */ '@/modules/company/_views/Index'
      ),
    meta: { section: 'company' },
    // redirect: { name: 'company_details' },
    redirect: to => {
      let currentUserRole = store.getters['LoginStore/loggedUserRoles']
      if (
        currentUserRole.some(el =>
          ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER'].includes(el)
        )
      ) {
        return '/company/details'
      }
      if (currentUserRole.some(el => ['ROLE_BOOKKEEPER'].includes(el))) {
        return '/company/transaction-fields'
      }
      return '/dashboard'
    },

    children: [
      {
        path: 'details',
        name: 'company_details',
        meta: {
          section: 'company',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
        },
        component: () =>
          import(
            /* webpackChunkName; 'company-details' */ '@/modules/company/_views/company_details/CompanyDetailsIndex'
          )
      },
      {
        path: 'transaction-fields',
        name: 'transaction_fields',
        meta: {
          section: 'company',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_ADMIN', 'ROLE_BOOKKEEPER']
        },
        component: () =>
          import(
            /* webpackChunkName: 'company-transactions-fields' */ '@/modules/company/_views/transaction_fields/TransactionFieldsIndex'
          )
      },
      {
        path: 'expense-fields',
        name: 'expense_fields',
        meta: {
          section: 'company',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_ADMIN',
            'ROLE_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'company-expense-fields' */ '@/modules/company/_views/expense_fields/ExpenseFieldsIndex'
          )
      },
      {
        path: 'integrations',
        name: 'integrations',
        meta: {
          section: 'company',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_ADMIN',
            'ROLE_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'company-integrations-fields' */ '@/modules/company/_views/integrations/IntegrationsIndex'
          )
      },
      {
        path: 'integrations/:erp',
        name: 'integration_detail',
        meta: {
          section: 'company',
          breadcrumb: 'integration',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_ADMIN',
            'ROLE_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'company-integration-detail' */ '@/modules/company/_views/integration_detail/IntegrationDetailIndex'
          )
      },
      {
        path: 'export-settings',
        name: 'export_settings',
        meta: {
          section: 'company',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_ADMIN',
            'ROLE_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'company-export-fields' */ '@/modules/company/_views/export_settings/ExportSettingsIndex'
          )
      }
    ]
  }
]
